import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
} from '@chakra-ui/react';

type SubmissionStatus = 'idle' | 'submitting' | 'polling' | 'success' | 'error';

interface SubmissionStatusAlertsProps {
  status: SubmissionStatus;
  errorMessage?: string | null;
}

const SubmissionStatusAlerts = ({
  status,
  errorMessage,
}: SubmissionStatusAlertsProps) => {
  if (status === 'submitting') {
    return (
      <Alert status="info" mb={4}>
        <AlertIcon />
        <Box>
          <AlertTitle>Submitting referral...</AlertTitle>
          <AlertDescription>
            Please wait while we submit your referral.
          </AlertDescription>
        </Box>
      </Alert>
    );
  }

  if (status === 'polling') {
    return (
      <Alert status="info" mb={4}>
        <AlertIcon />
        <Box>
          <AlertTitle>Creating Jira ticket...</AlertTitle>
          <AlertDescription>
            Your referral has been submitted. Please wait while we create the
            Jira ticket.
          </AlertDescription>
        </Box>
      </Alert>
    );
  }

  if (status === 'success') {
    return (
      <Alert status="success" mb={4}>
        <AlertIcon />
        <Box>
          <AlertTitle>Referral submitted successfully!</AlertTitle>
          <AlertDescription>
            The Jira ticket has been created. The form is now locked.
          </AlertDescription>
        </Box>
      </Alert>
    );
  }

  if (status === 'error') {
    return (
      <Alert status="error" mb={4}>
        <AlertIcon />
        <Box>
          <AlertTitle>Jira ticket creation failed</AlertTitle>
          <AlertDescription>
            {errorMessage ||
              'There was an issue creating the Jira ticket. Please contact support.'}
          </AlertDescription>
        </Box>
      </Alert>
    );
  }

  return null;
};

export default SubmissionStatusAlerts;
